export class XeroIsEntityAuthorizedRequest{
    public customerId!:number;
    public clientIds:number[]=[];
}